<template>
  <a-modal
    v-model:visible="visible"
    title="分配区域"
    :body-style="{ padding: '30px' }"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item label="客户区域" v-bind="validateInfos.customerRegion">
        <!-- <CustomerAreaCascader appId="cos_fbu" deptInfoId="815717" v-model:value="dataForm.customerRegion" /> -->
        <CustomerAreaCascader appId="cos_fbu" v-model:value="dataForm.customerRegion" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { publicCustomerAllotRegion } from '@/api/gucangSales/customerCenter'
import type { SalesClueListItem } from '@/typings/api/clueManage'

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ customerRegion: string; cosIdList: any[] }>({ customerRegion: '', cosIdList: [] })
const formRules = reactive({
  customerRegion: [{ required: true, message: '请选择客户区域' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.cosIdList = selectedData.value.map((item: SalesClueListItem) => item.cosId)
    const params = Object.assign({}, dataForm)
    publicCustomerAllotRegion(params)
      .then(() => {
        emit('fetch', dataForm.customerRegion)
        DcMessage.success('分配客户区域成功')
        resetFields()
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'CustomerAllotRegion' }
</script>
  <style scoped></style>
